import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy, onMount } from "svelte";
import { Compartment } from "@codemirror/state";
import { EditorView } from "@codemirror/view";

var root = $.from_html(`<div></div>`);

export default function CodeMirror($$anchor, $$props) {
	$.push($$props, true);

	let doc = $.prop($$props, 'doc', 3, ""),
		extensions = $.prop($$props, 'extensions', 19, () => []),
		className = $.prop($$props, 'class', 3, "");

	let dom;
	let view = null;
	let lastDoc = doc();
	let measureFrame = 0;
	const extensionsCompartment = new Compartment();

	function scheduleMeasure() {
		if (!view || measureFrame) return;

		measureFrame = window.requestAnimationFrame(() => {
			measureFrame = 0;
			view?.requestMeasure();
		});
	}

	onMount(() => {
		view = new EditorView({
			doc: doc(),
			parent: dom,
			extensions: [
				extensionsCompartment.of(extensions()),
				EditorView.updateListener.of((update) => {
					if (!update.docChanged || !view) return;

					lastDoc = update.state.doc.toString();
					$$props.onChange?.(lastDoc, view, update.transactions);
				})
			]
		});

		$$props.onEditorView?.(view);

		const resizeObserver = new ResizeObserver(scheduleMeasure);

		resizeObserver.observe(dom);
		scheduleMeasure();

		return () => {
			resizeObserver.disconnect();

			if (measureFrame) {
				window.cancelAnimationFrame(measureFrame);
				measureFrame = 0;
			}
		};
	});

	$.user_effect(() => {
		if (!view) return;

		view.dispatch({ effects: extensionsCompartment.reconfigure(extensions()) });
		scheduleMeasure();
	});

	$.user_effect(() => {
		if (!view || doc() === lastDoc) return;

		lastDoc = doc();

		view.dispatch({
			changes: { from: 0, to: view.state.doc.length, insert: doc() }
		});

		scheduleMeasure();
	});

	onDestroy(() => {
		view?.destroy();
		view = null;
	});

	var div = root();

	$.bind_this(div, ($$value) => dom = $$value, () => dom);
	$.template_effect(() => $.set_class(div, 1, `codemirror ${className()}`));
	$.append($$anchor, div);
	$.pop();
}